import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ERR_MESSAGES } from '@shared/constants/messages.constants';
import { OFFLINE_SKIP_401_LOGOUT } from '@shared/constants/offline.constants';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { STORAGE } from '@shared/constants/storage.constants';
import { TOAST_TYPE } from '@shared/constants/toast.constants';
import { AuthService } from '@shared/services/auth/auth.service';
import { StorageService } from '@shared/services/storage/storage.service';
import { ToastService } from '@shared/services/toast/toast.service';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const authService = inject(AuthService);
  const storageService = inject(StorageService);
  const skip401Logout = req.context.get(OFFLINE_SKIP_401_LOGOUT);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Other errors are not caught (404 etc) and should be handled by the callers if necessary
      if (error.status === 401 && !skip401Logout) {
        toastService.show(ERR_MESSAGES.SESSION_EXPIRED, TOAST_TYPE.ERROR)
        authService.logout();
        storageService.remove(STORAGE.USER);
        storageService.remove(STORAGE.ACCESS_TOKEN);
        storageService.remove(STORAGE.USER_PERMISSIONS);
        storageService.remove(STORAGE.REGION_FILTER);
        sessionStorage.clear();

        // Reload the app
        window.location.href = SITE_LINKS.AUTH.LOGIN;
      }
      else if (error.status === 500) {
        toastService.show(ERR_MESSAGES.INTERNAL_SERVER_ERROR, TOAST_TYPE.ERROR);
      }
      else if (error.status === 403) {
        const isFuturePriceList = error.url?.includes('future-price/list');
        if (!isFuturePriceList) {
          let action = error.url?.includes('customer/reminders') ? $localize`:@@reminders:Reminders` : '';
          toastService.show(`${action}: ${ERR_MESSAGES.FORBIDDEN}`, TOAST_TYPE.ERROR);
        }
      }

      return throwError(() => error);
    })
  );
};
